import React, { useEffect } from 'react';

import { fetchAuthenticated, get } from 'services/fetch';
import { emitEvent } from 'utils/events';

import EquipmentMobileOperatorForm from 'components/forms/EquipmentMobileOperatorForm';
import { logAction } from 'utils/logs';

export default function NewEquipmentMobileOperator(props) {
  const { history, setBreadcrumbs } = props;

  // Set breadcrumbs
  useEffect(() => {
    setBreadcrumbs([
      { path: '/cadastros/operadoras', label: 'Operadoras' },
      { path: '', label: 'Nova Operadora' }
    ]);
    return () => setBreadcrumbs([]);
  }, [setBreadcrumbs])

  // Handle form submit
  const handleSubmit = async (data) => {
    const response = await fetchAuthenticated('post', 'equipment-mobile-operator', data);

    if (!response.ok) {
      throw new Error('');
    } else {
      const data = await response.json();
      if (data) {
        for (const o of data) {
          logAction(`Criação da operadora ${o.name}`);
        }
      }
      emitEvent('showSnack', { message: 'Operadora criada com sucesso', type: 'success' });
      history.push(`/cadastros/operadoras`);
    }
  }

  // Handle cancel click
  const handleCancel = async () => {
    history.push('/cadastros/operadoras');
  }


  return (
    <div>
      <EquipmentMobileOperatorForm
        title='Nova Operadora'
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
      />
    </div>
  )
}
